import { psAxios } from '@patsnap/common-ps-http';
import _ from 'lodash';

function insertPreRequestPath(url: string, basePath = 'share'): string {
    const urlObj = new URL(url)
    const requestPath = urlObj.pathname
    if (requestPath.startsWith('/eureka/')) {
        urlObj.pathname = requestPath.replace('/eureka/', `/eureka/${basePath}/`)
    } else if (requestPath.startsWith('/eureka-rd-agent/triz-mind/')) {
        if (basePath === 'guest') {
            urlObj.pathname = requestPath.replace('/eureka-rd-agent/triz-mind/', `/eureka/${basePath}/eureka-rd-agent/triz-mind/`)
        } else {
            urlObj.pathname = requestPath.replace('/eureka-rd-agent/triz-mind/', `/eureka-rd-agent/${basePath}/triz-mind/`)
        }
    } else if (requestPath.startsWith('/eureka-rd-agent/tech-mind/')) {
        urlObj.pathname = requestPath.replace('/eureka-rd-agent/tech-mind/', `/eureka-rd-agent/${basePath}/tech-mind/`)
    } else if (requestPath.startsWith('/eureka-rd-agent/')) {
        urlObj.pathname = requestPath.replace('/eureka-rd-agent/', `/eureka-rd-agent/${basePath}/`)
    } else {
        urlObj.pathname = `/eureka/${basePath}${requestPath}`
    }
    return urlObj.toString()
}

/**
 * 分享后，需要将请求路径中前面加上/eureka/share，被分享人可以访问到分享的资源
 */
const needPreShareAPIList = [
    /**
     * 以下接口需要将请求路径中/eureka替换为/eureka/share
     */
    /**
     * TechMind 分享
     */
    'tech-mind/[^/]+',
    'tech-mind/job/[^/]+',
    'rd-agent/tech-mind/sse/[^/]+',

    /**
     * Mind 分享
     */
    'triz-mind/message',
    'triz-mind/version',
    'triz-mind/idea/novelty-copy',
    'triz-mind/idea/validation-copy',
    'triz-mind/idea/refine-stream',

    /*
    * Triz Pro
    * */
    'eureka-rd-agent/triz-mind/[^/]+',

    /*
    * Triz Skill
    * */
    'eureka-rd-agent/rd-triz-mind/[^/]+'
];

/**
 * 游客版，需要将请求路径中前面加上/eureka/guest，游客可以访问接口
 */
const needPreGuestAPIList = [
    /**
     * 以下接口需要将请求路径中/eureka替换为/eureka/guest
     */

    /**
     * Mind 游客版
     */
    'tech-mind/init',
    'tech-mind/chat',
    'tech-mind/run',
    'tech-mind/push-direction',
    'tech-mind/invention-principles/refresh',

    /**
     * Triz skill 游客版
     */
    'eureka-rd-agent/rd-triz-mind/init',
    'eureka-rd-agent/rd-triz-mind/confirm',
    'eureka-rd-agent/rd-triz-mind/chat',
    'eureka-rd-agent/rd-triz-mind/upload-file/batch',
    'eureka-rd-agent/rd-triz-mind/upload-file/delete'
];

function escapeRegExp(string: string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

const whiteListForJs = _.map(needPreShareAPIList, (item) => {
    const replaceKongRule = escapeRegExp(item.replace(/\[\^\/\]\+/g, '@'));
    const buildJsExp = replaceKongRule.replace(/@/g, '[a-zA-Z0-9_-]+') + '$';
    return new RegExp(buildJsExp);
});

const guestWhiteListForJs = _.map(needPreGuestAPIList, (item) => {
    const replaceKongRule = escapeRegExp(item.replace(/\[\^\/\]\+/g, '@'));
    const buildJsExp = replaceKongRule.replace(/@/g, '[a-zA-Z0-9_-]+') + '$';
    return new RegExp(buildJsExp);
});

export const airShareInterceptor = async(config) => {
    const fullUrl = config.url.startsWith('http') ? config.url : config.baseURL + config.url
    if (_.some(whiteListForJs, (item) => item.test(fullUrl.split('?')[0]))) {
        config.url = insertPreRequestPath(fullUrl);
    }

    if (_.some(guestWhiteListForJs, (item) => item.test(fullUrl.split('?')[0]))) {
        config.url = insertPreRequestPath(fullUrl, 'guest');
    }
    return config;
};

export function injectAirShareInterceptor() {
    if (!psAxios.psInterceptors.airShareInterceptor) {
        psAxios.psInterceptors.airShareInterceptor = psAxios.interceptors.request.use(airShareInterceptor, () => { });
    }
}

export function ejectAirShareInterceptor() {
    psAxios.interceptors.request.eject(
        psAxios.psInterceptors.airShareInterceptor
    );
}
